module.exports = __webpack_public_path__ + "img/coin-clatter-svgrepo-com.8d77a542.svg";